module.exports = __webpack_public_path__ + "static/bird2-83310edc2fad51b427c03f9215f0a4bf.png";